import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReceivableTable } from "../../types/receivable.types";

interface ReceivableTableState {
  list: ReceivableTable[];
  paginator: any;

  pendingCustomerReceivables: ReceivableTable[];

  page: number;
  size: number;
  sort: string;

  loading: boolean; 
  error: string | null;
}

const initialState: ReceivableTableState = {
  list: [],
  paginator: null,

  pendingCustomerReceivables: [],

  page: 0,
  size: 5,
  sort: "dueDate,desc",

  loading: false,
  error: null,
};

const receivableTableSlice = createSlice({
  name: "receivableTable",
  initialState,
  reducers: {

    // 🔄 loading
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    // ❌ error
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    // 📊 set data
    setReceivables(
      state,
      action: PayloadAction<{ content: ReceivableTable[] }>
    ) {
      state.list = action.payload.content;
      state.paginator = action.payload;
      state.loading = false;
    },

    // 🧹 limpiar tabla
    clearReceivables(state) {
      state.list = [];
      state.paginator = null;
    },

    // 📄 paginación
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },

    setSize(state, action: PayloadAction<number>) {
      state.size = action.payload;
    },

    setSort(state, action: PayloadAction<string>) {
      state.sort = action.payload;
    },

    setPendingCustomerReceivables(
      state,
      action: PayloadAction<ReceivableTable[]>
    ) {
      state.pendingCustomerReceivables =
        action.payload;
    },

    clearPendingCustomerReceivables(state) {
      state.pendingCustomerReceivables = [];
    },
  },
});

export const {
  setLoading,
  setError,
  setReceivables,
  clearReceivables,
  setPage,
  setSize,
  setSort,
  setPendingCustomerReceivables,
  clearPendingCustomerReceivables,
} = receivableTableSlice.actions;

export default receivableTableSlice.reducer;